

import styles from './Socials.module.css'
import {BsInstagram} from "react-icons/bs";
import {FaTelegram} from "react-icons/fa";
import {AiFillLinkedin} from "react-icons/ai";

const Socials = () => {

    return (
       <div className={styles.socials}>
           <a href="https://www.instagram.com/_david645/?next=%2F"> <BsInstagram className={styles.icons}/> </a>
           <a href="https://t.me/dav1d645"><FaTelegram className={styles.icons}/></a>
           <a href="https://www.linkedin.com/in/david-bogomolov-569830284/"> <AiFillLinkedin className={styles.icons}/></a>
       </div>
    )

}


export default Socials